import clsx from "clsx";
import { PropsWithChildren } from "react";

type SideNavigationProps = PropsWithChildren & {
  isOpen: boolean;
};

export const SideNavigation = ({ children, isOpen }: SideNavigationProps) => (
  <div
    className={clsx(
      "duration-400 ease-ease fixed bottom-0 start-0 top-0 z-50 h-full w-full bg-surface-emphasis transition-all",
      isOpen ? "translate-x-0" : "ltr:-translate-x-full rtl:translate-x-full",
    )}
    data-testid="side-navigation"
  >
    <div className="flex h-full flex-col overflow-scroll scroll-smooth p-4">
      {children}
    </div>
  </div>
);

export const SideNavigationHeader = ({ children }: PropsWithChildren) => (
  <div className="flex justify-end">{children}</div>
);

export const SideNavigationContent = ({ children }: PropsWithChildren) => (
  <div className="my-6 flex flex-grow flex-col">{children}</div>
);

export const SideNavigationFooter = ({ children }: PropsWithChildren) => (
  <div className="flex">{children}</div>
);
